import React, { useEffect, useState } from 'react';
import { Link as ScrollLink, animateScroll } from 'react-scroll';
import content from '../../content';
import './Header.css';

const Header = ({ navItems, theme, onThemeToggle }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenus = () => {
    setMenuOpen(false);
  };

  const handleHomeClick = () => {
    animateScroll.scrollToTop({ smooth: true, duration: 400 });
    closeMenus();
  };

  const renderScrollLinks = () => (
    <>
      {navItems.map(({ id, label }) => (
        <ScrollLink key={id} to={id} smooth={true} duration={400} onClick={closeMenus}>
          {label}
        </ScrollLink>
      ))}
    </>
  );

  return (
    <nav className={`header ${scrolled ? 'scrolled' : ''} ${isMenuOpen ? 'open' : ''}`}>
      <div className="header-left">
        <button
          type="button"
          className="logo-button"
          onClick={handleHomeClick}
          aria-label={`${content.meta.name} — back to top`}
        >
          <span className="logo-text">{content.meta.initials}</span>
        </button>
      </div>

      <div className="header-center">{renderScrollLinks()}</div>

      <div className="header-right">
        <button
          type="button"
          className="theme-toggle"
          onClick={onThemeToggle}
          aria-label="Toggle theme"
          title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        >
          {theme === 'dark' ? '☀️' : '🌙'}
        </button>
      </div>

      <button
        type="button"
        className="hamburger"
        onClick={() => setMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        <span className={`ham-line ${isMenuOpen ? 'open' : ''}`}></span>
        <span className={`ham-line ${isMenuOpen ? 'open' : ''}`}></span>
        <span className={`ham-line ${isMenuOpen ? 'open' : ''}`}></span>
      </button>

      {isMenuOpen && (
        <div className="dropdown">
          {renderScrollLinks()}
          <button
            type="button"
            className="dropdown-theme-btn"
            onClick={() => { onThemeToggle(); closeMenus(); }}
          >
            {theme === 'dark' ? '☀️ Light Mode' : '🌙 Dark Mode'}
          </button>
        </div>
      )}
    </nav>
  );
};

export default Header;
